// Keep .js URLs so common reverse-proxy MIME tables serve both module assets
// as JavaScript without requiring an explicit .mjs mapping.
const PDFJS_MODULE_SRC = '/assets/pdfjs/pdf.min.js';
const PDFJS_WORKER_SRC = '/assets/pdfjs/pdf.worker.min.js';

let loaderPromise = null;

function configuredPdfJs() {
  const pdfjs = globalThis.pdfjsLib;
  if (typeof pdfjs?.getDocument !== 'function') return null;
  pdfjs.GlobalWorkerOptions.workerSrc = PDFJS_WORKER_SRC;
  return pdfjs;
}

export function loadPdfJs() {
  const loaded = configuredPdfJs();
  if (loaded) return Promise.resolve(loaded);
  if (loaderPromise) return loaderPromise;
  if (typeof document === 'undefined') return Promise.reject(new Error('PDF.js requires a browser'));

  loaderPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[data-pdfjs-module="${PDFJS_MODULE_SRC}"]`);
    const script = existing || document.createElement('script');
    const cleanup = () => {
      script.removeEventListener('load', handleLoad);
      script.removeEventListener('error', handleError);
    };
    const fail = (error) => {
      cleanup();
      // A failed script will never emit another load event. Remove it so a
      // later preview retries the request instead of waiting on a dead tag.
      script.remove();
      reject(error);
    };
    const handleLoad = () => {
      const pdfjs = configuredPdfJs();
      if (pdfjs) {
        cleanup();
        resolve(pdfjs);
      } else fail(new Error('PDF.js loaded without exposing its browser API'));
    };
    const handleError = () => fail(new Error('Could not load the PDF.js browser module'));
    script.addEventListener('load', handleLoad, { once: true });
    script.addEventListener('error', handleError, { once: true });
    if (!existing) {
      script.type = 'module';
      script.src = PDFJS_MODULE_SRC;
      script.dataset.pdfjsModule = PDFJS_MODULE_SRC;
      document.head.appendChild(script);
    }
  }).catch((error) => {
    loaderPromise = null;
    throw error;
  });

  return loaderPromise;
}
